import { useEffect } from "react"
import { useAppToast } from "@ui-seeker/app"
import { postSubmit } from "@ui-seeker/utils"

import { BACKEND_APIS } from "@constants"
import {
    detailsData,
    detailsRow,
    isLoadingDetails,
    selectedCustomer,
} from "../@signals"


/**
 * Fetches the drawer payload for whichever row is open.
 *
 * One request per row opened, and none at all until a row is: the text and the
 * media URLs are the bulk of the response, and only whoever clicks a row sees
 * them. The table already carries the `has*` flags, so the drawer can render
 * its empty states before this resolves.
 */
export default function useScrapingDataReviewDetails() {
    const { showToast } = useAppToast()
    const row = detailsRow.value

    useEffect(() => {
        if (!row) {
            detailsData.value = null
            return
        }

        isLoadingDetails.value = true
        detailsData.value = null

        postSubmit(`${BACKEND_APIS.SCRAPING_DATA_REVIEW}/details`, {
            customer: selectedCustomer.value?.value,
            siteID: row.siteID,
            productID: row.productID,
        })
            .then(res => { if (res) detailsData.value = res })
            .catch(() => showToast.error('Error loading product details'))
            .finally(() => { isLoadingDetails.value = false })
    }, [row?.siteID, row?.productID])

    return {
        isLoading: isLoadingDetails.value,
        details: detailsData.value,
        row,
    }
}
